import { isLiveChat } from 'util/chat';
import { ESCALATABLE_CONVERSATION_TYPES } from '../constants/integrations';
import { getExpertId } from 'util/parseSelectors';
import { REACH_OUT_STATUSES } from 'constants/partnerReachOut';

export const isEscalatableProvider = (ticket) => {
  return !!ticket && !!ticket.ticketType && ESCALATABLE_CONVERSATION_TYPES.includes(ticket.ticketType.toLowerCase());
};

export const formatTicketBody = (ticket) => {
  return ticket && ticket.ticketBody && ticket.ticketBody.replace(/(<([^>]+)>)/gi, '');
};

export const isTicketLiveChat = (ticket) => {
  if (!ticket) {
    return false;
  }
  const { communicationType } = ticket;

  return isLiveChat(communicationType);
};

export const isTicketReviewTicket = (ticket, isAPartnerProtector) => {
  if (!ticket) {
    return false;
  }

  if (isAPartnerProtector) {
    return ticket.reviewExpertId === getExpertId();
  }

  return false;
};

export const isValidPartnerReachOutTicket = (ticket) =>
  !!ticket?.pendingPartnerReachOut &&
  Object.values(REACH_OUT_STATUSES).includes(ticket.pendingPartnerReachOut.reachOutStatus) &&
  !!ticket.pendingPartnerReachOut.flowPath &&
  !!ticket.pendingPartnerReachOut.simplrTag;

export const hasPartnerRespondedToReachOut = (ticket) =>
  isValidPartnerReachOutTicket(ticket) &&
  ticket.pendingPartnerReachOut.reachOutStatus === REACH_OUT_STATUSES.PARTNER_RESPONDED;

export const hasSimplrSubmittedReachOut = (ticket) =>
  isValidPartnerReachOutTicket(ticket) &&
  ticket.pendingPartnerReachOut.reachOutStatus === REACH_OUT_STATUSES.SIMPLR_SUBMITTED;

export const hasSimplrAgentActionedToReachOut = (ticket) =>
  isValidPartnerReachOutTicket(ticket) &&
  ticket.pendingPartnerReachOut.reachOutStatus === REACH_OUT_STATUSES.SIMPLR_AGENT_ACTIONED;

export const partnerReachOutRetryNeeded = (ticket) =>
  isValidPartnerReachOutTicket(ticket) &&
  [REACH_OUT_STATUSES.TIMEOUT, REACH_OUT_STATUSES.ERROR].includes(ticket.pendingPartnerReachOut.reachOutStatus);
